const nbTranslations = {
    confirmationScreen: {
        consumerLoanTitle: 'Forbrukslån',
        refinancingTitle: 'Refinansiering',
        creditCardTitle: 'Våre kredittkort',
        title: 'Beregn pris og søk',
        description: '{} leveres av Kredittbanken. For at Kredittbanken enkelt skal behandle søknaden din, deler vi opplysninger om deg mens du søker.',
        toggleButtonText: 'Hvilke opplysninger deles?',
        listTitle: 'Du deler:',
        phone: 'telefonnummer',
        email: 'e-post',
        fnr: 'fødselsnummer',
        customerRelationship: 'bekreftelse på at du er bankkunde hos oss',
        loanLinkText: 'Beregn pris og søk',
        creditCardLinkText: 'Søk om kredittkort',
        eikaEmployeeCardLinkText: 'Søk om bedriftskort',
    },
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
        errorCodeHeader: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
        informationModalTitle: 'Hva kan jeg bruke feilkoden til?',
        informationModalDescription: 'Når det oppstår en feil, hender det man blir nødt til å kontakte banken for å få hjelp. Da er det veldig nyttig å ha en feilkode banken kan få, så vi lettere kan se hva som er gått galt. \n' +
            '\n' +
            'Ta et skjermbilde av feilmeldingen eller les opp feilkoden til personen du prater med på telefon. Skriver du med oss via meldinger i mobil- eller nettbank? Da kan du enkelt klikke «Kopier feilkode», for deretter å lime den inn i meldingsvinduet til den bankansatte du skriver med.\n' +
            '\n' +
            'Sammen finner vi ut av hva som har gått galt. Lykke til!',
    },
    goBack: 'Gå tilbake',
    nominalInterest: 'Nominell rente {}%',
    loanListTitle: 'Andre lån',
    loanOwners: {
        title: 'Låntakere',
        accountRole: {
            DEBTOR: 'Eier av lån',
            CO_DEBTOR: 'Medlåntaker',
            GUARANTOR: 'Kausjonist',
            UNKNOWN: 'Ukjent',
        },
    },
    loanDetails: {
        title: 'Detaljer',
        name: 'Navn på lån',
        intialAmount: 'Opprinnelig lånebeløp',
        maturityDate: 'Nedbetalingsdato',
        effectiveInterest: 'Effektiv rente',
        paymentDate: 'Forfallsdato',
        paymentDay: '{}. hver måned',
        instalmentAmount: 'Terminbeløp',
    },
    loanInterest: {
        nominalInterest: 'Nominell rente',
        effectiveInterest: 'Effektiv rente {}%',
        loanRepaymentLinkTitle: 'Se nedbetalingsplan',
        loanRepaymentLinkDescription: 'Hos Kredittbanken',
    },
    loanOverview: {
        accountName: 'Kontonavn',
        accountNumber: 'Kontonummer',
        disposible: 'Disponibelt',
        moneyOnTheWay: 'Pengene er på vei. Det kan ta noen virkedager før pengene er utbetalt.',
        interest: 'Nominell rente',
        paymentDueDate: 'Neste innbetaling',
        instalmentAmount: 'Beløp',
        extraPayment: 'Ekstra innbetaling',
        more: 'Mer',
        changeDate: 'Endre forfall',
        seeDocuments: 'Se faktura og dokumenter',
        atKredittbanken: 'Hos Kredittbanken',
        infoKredittbankne: 'Våre forbrukslån og kredittkort leveres av Kredittbanken',
        showLoanAtKredittbanken: 'Se lånet ditt hos Kredittbanken',
        loanPayedDown: 'Lånet er nedbetalt',
    },
    transactions: {
        noTransactions: 'Her har det ikke skjedd så mye!',
        noMoreTransactionsToLoad: 'Det var alle transaksjonene på denne kontoen',
        reserved: 'Reservert',
        couldNotLoadMoreTransactions: 'Vi beklager, det har skjedd en teknisk feil så vi klarte ikke å laste flere transaksjoner. Prøv igjen litt senere.',
        tryAgain: 'Prøv igjen',
    },
    creditCardScreen: {
        infoTitle: 'Du har allerede et kredittkort hos oss',
        infoText: 'Du kan søke om kredittgrense opp til 100 000 kr, eller søke om et nytt kredittkort',
        cardListTitle: 'Øk kredittgrense',
        creditLimitText: 'Kredittgrensen din er {} kr',
        applyForCreditCardTitle: 'Søk om kredittkort',
        applyForEikaEmployeeTitle: 'Søk om bedriftskort',
        applyForEikaEmployeeCardText: 'For deg som ønsker å skille jobbrelaterte utgifter fra privatøkonomien',
        blockedCreditLimit: 'Du kan ikke søke om økt kredittgrense på dette kortet',
        creditCardLimitErrorTitle: 'Du kan ikke søke om økt kredittgrense akkurat nå',
        creditCardLimitErrorText: 'Det kan være flere grunner til det. Prøv igjen senere eller kontakt kundeservice hvis du trenger hjelp.',
        buttonOk: 'Ok',
    },
    refinancingCalculator: {
        estimateTitle: 'Sjekk hvor mye du kan spare',
        monthlyPayment: 'Månedlig kostnad',
        estimatedSavings: 'Total mulig besparelse',
        buttonSearchHousingLoan: 'Gå til søknad',
        nominalInterest: 'Nominell rente',
        interestRateMinMax: 'Fra {} til {} %',
        wishedLoanAmount: 'Ønsket lånebeløp',
        loanAmountMinMax: 'Fra {} til {}',
        effectiveInterestRate: 'Effektiv rente',
        downPaymentTime: 'Nedbetalingstid',
        paymentTimeMinMax: 'Fra {} til {} år',
        estimateText: 'Basert på gjennomsnittlig besparelse for kunder som har refinansiert hos Kredittbanken ASA.',
        priceExample: 'Eksempel:',
        priceExampleText: '{} {} kr over {} år, nominell rente {} %, effektiv rente {} %. Totalt beløp å betale: {} kr. Kostnad: {} kr.',
        contactAdvisor: 'Snakk med en rådgiver',
        aboutRefinancing: 'Om refinansiering',
        tryAgain: 'Prøv igjen',
        errorMessage: 'Vi beklager, men noe gikk galt',
        loanAmountError: 'Beløpet er for lavt eller høyt',
        termYearsError: 'Renten er for lav eller høy',
        interestRateError: 'Nedbetalingstid er for lang',
    },
};
export default nbTranslations;
//# sourceMappingURL=data:application/json;base64,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